import React from "react";
import { BlogCard } from "./components/BlogCard";

import blog1 from "./assets/blog1.jpg";
import blog2 from "./assets/blog2.png";
import blog3 from "./assets/blog3.png";
import blog5 from "./assets/blog5.jpg";
import psdi from "./assets/psdi.png";

interface BlogPost {
  title: string;
  excerpt: string;
  author: string;
  date: string;
  imageUrl?: string | undefined;
  slug: string;
}

const Blog: React.FC = () => {
  const blogPosts: BlogPost[] = [
    {
      title:
        "Data Revival turn security into investment following a Secure Innovation Security Review",
      excerpt:
        "Data Revival is a unique AI end-to-end data structuring and retrieval system for chemical archives. They recently spun out of Southampton University and within 8 weeks had closed their pre-seed round.",
      author: "UKRI",
      date: "Dec 28, 2025",
      imageUrl: blog1,
      slug: "https://iuk-business-connect.org.uk/casestudy/data-revival-turn-security-into-investment-following-a-secure-innovation-security-review/?utm_campaign",
    },
    {
      title: "Unleashing the power of trapped information",
      excerpt:
        "Data Revival is a unique AI end-to-end data structuring and retrieval system, giving you unprecedented, contextual access to all your complex data sources.",
      author: "Future Worlds",
      date: "Nov 12, 2025",
      imageUrl: blog2,
      slug: "https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://labs.futureworlds.com/data-revival/&ved=2ahUKEwjh_YnU4qGRAxUNUUEAHQZIGr0QFnoECD0QAQ&usg=AOvVaw2jBJKlJPyDAhIKan6IIsZ3",
    },
    {
      title: "Data Revival scoops national award for innovation",
      excerpt:
        "Sam Munday, co-founder of Data Revival (Future Worlds Cohort 22) has scooped a national award from Innovate UK, the UK's Innovation Agency. The prestigious award will support them to grow their innovative business idea which offers a unique AI end-to-end data structuring and retrieval system, giving unprecedented, contextual access to all complex data sources.",
      author: "Alex Dunlop",
      date: "Feb 14, 2024",
      imageUrl: blog3,
      slug: "https://www.google.com/url?sa=t&source=web&rct=j&opi=89978449&url=https://futureworlds.com/data-revival-scoops-national-award-for-innovation/&ved=2ahUKEwjh_YnU4qGRAxUNUUEAHQZIGr0QFnoECD8QAQ&usg=AOvVaw2zlEgvL5oJnsDOAZ0eUtYq",
    },
    {
      title: "Data Revival",
      excerpt:
        "The Data Revival project is an innovative initiative aimed at utilising machine-learning to unlock the potential of unstructured and underutilised data, particularly in the field of chemistry and chemical research.",
      author: "PSDI",
      date: "May 19, 2025",
      imageUrl: psdi,
      slug: "https://www.psdi.ac.uk/about-psdi/our-outputs/data-revival/",
    },
    {
      title: "Welcome Back Data Revival",
      excerpt:
        "Samuel Munday, the company's co-founder, said, \"We're really excited to pick up the keys to our new office in the amazing facilities at the University of Southampton Science Park, incredibly well placed at just a 5 minute walk to the local pub! Thanks to the Science Park team for getting us in and making us feel so welcome.\"",
      author: "Southampton Science Park",
      date: "Apr 14, 2025",
      imageUrl: blog5,
      slug: "https://www.science-park.co.uk/news/2025/welcome-back-data-revival",
    },
    {
      title:
        "Data Revival - Making the intangible tangible: The journey from lab notebook to digital insight",
      excerpt:
        "Welcome to the Physical Sciences Data Infrastructure (PSDI) webinar series. This webinar series is designed to communicate the PSDI work to a wider audience!",
      author: "PSDI",
      date: "June 11, 2025",
      imageUrl: psdi,
      slug: "https://guidance.psdi.ac.uk/docusaurus-pages/docs/training/webinars/data-revival/",
    },
  ].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <div className="bg-dark-bg min-h-screen">
      <div className="container mx-auto w-full max-w-4xl px-5 md:px-0 text-center">
        <h1 className="text-5xl md:text-[3.5rem] leading-none font-semibold pt-[10%]">
          <span className="bg-gradient-text bg-clip-text text-transparent">
            Insights & Updates <br /> from Data Revival
          </span>
        </h1>

        <p className="mt-6 text-white text-lg max-w-3xl mx-auto">
          Stay up to date with the latest research insights and industry
          perspectives from our team.
        </p>
      </div>

      <section className="mt-20 pb-16">
        <div className="container mx-auto w-full max-w-6xl px-5 md:px-0">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.map((post, index) => (
              <BlogCard
                key={index}
                title={post.title}
                excerpt={post.excerpt}
                author={post.author}
                date={post.date}
                imageUrl={post.imageUrl}
                slug={post.slug}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
